import React from "react";
import { Card, CardBody, Row, Col } from "reactstrap";
import { BsTrash, BsFillPencilFill } from "react-icons/bs";
import { getGridLineColor } from '../../helpers/utils'
import { GrView } from "react-icons/gr";
import { BiCloudDownload } from "react-icons/bi";

const InfoCard = ({
  showTime,
  name,
  id,
  index,
  onClick,
  onDelete,
  onView,
  onDownload 
}) => (
  <Card style={{ cursor: "pointer", marginBottom: "0px" }} className="card-chart">
    <CardBody style={{padding: "8px", paddingLeft: "5px", backgroundColor: (index % 2 === 0 ? "inherit" : getGridLineColor())}}>
      <Row>
        <Col xs={2} md={1} style={{display: "flex", alignItems: "center"}}>          
          {id}
        </Col>
        <Col xs={4} md={4} style={{display: "flex", alignItems: "center"}}>          
          {name}
        </Col>    
        <Col xs={3} md={4} className="display-none-xs">
          {showTime}
        </Col>
        <Col xs={3} md={3} style={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
          <BiCloudDownload 
            onClick={onDownload}
            className="icon-xs"
            style={{marginLeft: "5px", marginRight: "5px"}}
            title="Baixar"
            size= {20}
          />
          <GrView
            onClick={onView}
            className="icon-xs"
            style={{marginLeft: "5px", marginRight: "5px"}}
            title="Visualizar"
            size= {20}
          />   
          <BsTrash
            onClick={onDelete}
            title="Deletar"
            size= {20}
            color="#ec250d"
            className="icon-xs-0"
          /> 
          <BsFillPencilFill              
            size= {20}
            style={{marginLeft: "5px", marginRight: "5px"}}
            title="Editar"
            onClick={onClick}
            color="#4cd678"
            className="icon-xs"
          />
        </Col>
      </Row> 
    </CardBody>
  </Card>
);

export default InfoCard;
